import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class MessagesService {

  constructor(
    private messageService: MessageService,) { }

  showLoading() {
    // console.log('MessagesService:showLoading')
    this.messageService.add({ severity: 'info', summary: 'FireDNA', detail: 'Processing request...', sticky: true, key: 'loading' });
  }
  showFailureLoading() {
    console.log('MessagesService:showFailureLoading')
    this.messageService.add({ severity: 'error', summary: 'FireDNA', detail: 'Network connection unstable', sticky: true, key: 'loading' });
  }
  hideLoading() {
    this.messageService.clear('loading');
  }
}
